module.exports = __webpack_public_path__ + "img/5c46a62.png";